<div class="flex items-center justify-center h-full">
  <div class="flex md:w-2/4 mt-20 items-center justify-center text-center m-10">
    <activar-card>
      <div class="flex items-center justify-center">
        <activar-icon name="success" size="60px" class="mb-5" />
      </div>

      <h2 class="mb-3">Gracias por confiar en nosotros</h2>
      <div *showForChannels="['agents']" class="space-y-3">
        @if(quoterStoreService.state().user.isClient){
        <p class="text-sm sm:text-base leading-relaxed">Tu cliente podrá ver sus pólizas en la app refrescando la misma.</p>
        }@else {
        <p class="text-sm sm:text-base leading-relaxed">
          Envíamos un mail al cliente informando cómo ver su póliza y utilizar
          nuestra app.
        </p>
        }
      </div>

      <div *showForChannels="['direct']" class="mb-3">
        <p class="text-sm sm:text-base leading-relaxed"> Te enviamos un mail con credenciales para acceder a la app y controlar tu póliza.</p>
      </div>
      @if(isVehicle()){
      <p class="text-sm sm:text-base leading-relaxed mb-3">
        Recordá que la emisión de las pólizas se realizan con la primera
        activación.
      </p>
      }

      <div class="flex flex-col gap-3 mt-6" *showForChannels="['agents']">
        <activar-button color="primary" text="Volver al inicio" expand="full" fill="out" [routerLink]="quoterRoutePath" />
        @for(policy of policyResponse.policies; track policy.id){ 
          <activar-button color="primary" text="Ver póliza {{showName(policy.type)}}" expand="full" (click)="viewDetail(policy.id)" />
        }
        

      </div>
      @if(!isVehicle()){
      <div class="flex mt-6">
        <activar-button color="primary" text="Descargar certificado" expand="full" [loading]="loading()"
          loadingText="Descargando..." (click)="downloadCertificate()" />
      </div>
      }
    </activar-card>
  </div>
</div>